<script>
import { Line, mixins } from 'vue-chartjs';
// https://vue-chartjs.org/guide/#introduction

export default {
  name: 'LineChart',
  extends: Line,
  // The dashboard mounts these charts before its API call resolves, then fills
  // the arrays in place. renderChart() in mounted() alone therefore drew one
  // empty chart and never drew another - the object identity never changes, so
  // nothing told it to. reactiveProp watches chartData deeply and re-renders.
  // It also declares the chartData prop, so this component must not.
  mixins: [mixins.reactiveProp],
  props: {
    chartOptions: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  },
};
</script>
